/**
 * オーストラリア向けAWS設定
 */
module.exports = {
  Auth: {
    identityPoolId: 'ap-southeast-2:338812f1-1868-4aa5-8a0e-e1c9a5bee1b8',
    region: 'ap-southeast-2',
    userPoolId: 'ap-southeast-2_nXq3q12g2',
    userPoolWebClientId: '2f3scenq4m7t6oonlt7ihnkfd8',
    mandatorySignIn: false,
  },
  API: {
    endpoints: [
      { name: 'prod', endpoint: 'https://api-aus.senrigan-hihakai.com/prod' }
    ]
  },
  Storage: {
    bucket: 'document-aus.senrigan.konicaminolta.com',
    region: 'ap-southeast-2',
  },
}
